export default __webpack_public_path__ + "static/media/micimg1.885e26d7.webp";